module.exports = __webpack_public_path__ + "static/img/DEV1-CKwh8lpv.28031df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DEV1-CKwh8lpv.png
// module id = +1CG
// module chunks = 16